export default {
p362df000: "M4.16667 17.5C5.08714 17.5 5.83333 16.7538 5.83333 15.8333C5.83333 14.9129 5.08714 14.1667 4.16667 14.1667C3.24619 14.1667 2.5 14.9129 2.5 15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5Z",
p67ef620: "M4.16699 14.1667C4.16699 11.5146 5.22056 8.97104 7.09592 7.09568C8.97129 5.22032 11.5148 4.16675 14.167 4.16675",
p809180: "M15.8337 5.83333C16.7541 5.83333 17.5003 5.08714 17.5003 4.16667C17.5003 3.24619 16.7541 2.5 15.8337 2.5C14.9132 2.5 14.167 3.24619 14.167 4.16667C14.167 5.08714 14.9132 5.83333 15.8337 5.83333Z",
}

